import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Styles = styled.div`
    --n-primary-2: #0E3D5C;
    --n-grey-0: #fff;
    --n-grey-1: #F9F9F9;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-5: #aaa;
    background-color: var(--n-grey-0);
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    position: relative;
    .conector {
        z-index: 0;
        position: absolute;
        height: 2px;
        width: calc(100% - 8rem);
        top: calc(50% - 0.9rem);
        right: 4rem;
        background-color: var(--n-grey-2);
        .progress {
            width: 25%;
            height: 100%;
            background-color: var(--n-primary-2);
        }
    }
    .step{
        cursor: pointer;
        z-index: 10;
        display: flex;
        flex-direction: column;
        text-decoration: none;
        .icon {
            display: flex;
            justify-content: center;
            position: relative;
            .bg {
                border: 2px solid var(--n-grey-1);
                background-color: var(--n-grey-1);
                position: absolute;
                width: 46px;
                height: 46px;
                top: calc(50% - 25px);
                right: calc(50% - 25px);
                /* bottom: calc(50% - 24px);
                left: calc(50% - 24px); */
                border-radius: 10rem;
                display: flex;
            }
            svg {
                /* background-color: var(--n-grey-0); */
                padding: 12px;
                width: 24px;
                height: 24px;
                border: 2px solid var(--n-grey-2);
                border-radius: 10rem;
                fill: var(--n-grey-3);
                color: var(--n-grey-3);
                overflow: visible;
                position: relative;
            }
            
        }
        .title {
            font-size: 0.9rem;
            margin-top: 0.5rem;
            color: var(--n-grey-5);
            text-align: center;
        }
        &.active {
            .icon {
                .bg {
                    border: 2px solid var(--n-grey-0);
                    background-color: var(--n-grey-0);
                }
                svg {
                    border: 2px solid var(--n-primary-2);
                    border-radius: 10rem;
                    fill: var(--n-primary-2);
                    color: var(--n-primary-2);
                    overflow: visible;
                }
            }
            .title {
                color: var(--n-primary-2);
            }
        }
    }
    @media screen and (max-width: 850px) {
        padding: 0.2rem;
        gap: 0.5rem;
        .conector {
            height: 2px;
            width: calc(100% - 18px);
            top: 16px;
            right: 12px;
        }
        .step{
            .icon {
                .bg {
                    border: 1px solid var(--n-grey-1);
                    width: 23px;
                    height: 23px;
                    top: calc(50% - 13px);
                    right: calc(50% - 13px);
                }
                svg {
                    padding: 6px;
                    width: 12px;
                    height: 12px;
                    border: 1px solid var(--n-grey-2);
                }
            }
            &.active {
                .icon {
                    .bg {
                        border: 1px solid var(--n-grey-0);
                    }
                    svg {
                        border: 1px solid var(--n-primary-2);
                    }
                }
                .title {
                    color: var(--n-primary-2);
                }
            }
        }
    }
`


export function Steper(props) {
    const onclicked = (e) => {
        if(typeof props.setStep === "function"){
            props.setStep(e)
        }
    }
    const makeSteps = () => {
        let steps = props.steps;
        let stepKeys = Object.keys(props.steps)
        let fill = stepKeys.findIndex(value => value === props.step)
        return stepKeys.map((key, index) => {
            let value = steps[key];
            let link = props.base + key + props.post
            if(!props.editing){
                link = props.base
            }
            return (
                <div className={"step " + ((fill >= index) ? 'active' : '')} key={index} onClick={() => onclicked(key)}>
                    <div className="icon">
                        <div className="bg"></div>
                        {value.icon}
                    </div>
                    <div className="title">
                        {value.title}
                    </div>
                </div>
            )
        })
    }
    const getProgress = () => {
        
        let stepKeys = Object.keys(props.steps)
        let fill = stepKeys.findIndex(value => value === props.step);
        let buf = 0
        if(props.justify){
            if(window.innerWidth < 850){
                buf = 13
            } else {
                buf = 10
            }
        }
        // console.log(buf, stepKeys.length)
        return ((((fill)/(stepKeys.length - 1)) * (100 - (2*buf)))) + buf
    }
    let justify = ""
    if(props.justify){
        if(window.innerWidth < 850){
            justify = "0.2rem 5%"
        } else {
            justify = "1rem 10%"
        }
    }
    return (
        <Styles style={{padding: justify}}>
            <div className="conector"><div className="progress" style={{width: getProgress() + '%'}}></div></div>
            {makeSteps()}
        </Styles>
    )
}